import React, { useState, useEffect } from "react";
import { getClosedEvents, getAircraftList, getClosedEventsFilterCount } from "../../services/otsEventService";
import TitleBarClosed from "../TitleBar/TitleBarClosed";
import "../../theme/styles.css";
import OtsCloseHeaderCard from "./OtsCloseHeaderCard/OtsCloseHeaderCard";
import { OtsAircraft } from "../../Models/OtsAircraft";
import { Switch, Route, useHistory, useLocation } from "react-router-dom";
import EventDetails from "../EditOtsForm/EventDetails";
import EditModal from "../EditOtsForm/EditModal";
import { useDispatch, useSelector } from 'react-redux';
import { editAircraft } from "../../store/feature/OtsAircraftSlice";
import { useAuthentication } from "meportal/AuthenticationProvider";
import BackToTopButton from "../../helpers/BackToTopButton";
import ShowClosedEvents from "./ShowClosedEvents";
import FilterNavigation from "./FilterComponents/FilterNavigation";
import { ClosedSearchParams, ClosedSortingParams } from "../../Models/ClosedSearchParams";
import { convertClosedSearchParamsForApiCall } from "../../helpers/Util";

export default function ClosedEvents() {

  const dispatch = useDispatch();
  const { userData, getLatestAccessToken } = useAuthentication();
  const rootPath = "/closed-events";
  const history = useHistory();
  const location = useLocation();
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(true);
  const [otsClosedAircraft, setClosedOtsDashboard] = useState<OtsAircraft[]>(
    []
  );
  const [open, setOpen] = useState(false);
  const [loadedData, setLoadedData] = useState(false);
  // const [editToggle, setEditToggle] = useState(false); //changing edit modal open close
  const [reopenToggle, setReopenToggle] = useState(false);

  const [continousToken, setContinousToken] = React.useState("");  
    const [resetPage, setResetPage] = useState(true);
    const [filteredCount, setFilteredCount] = useState<number>(0);
  const closedAircraftData = useSelector((state) => state.otsAircraft.otsAircraft);
  const [sortChangeButtonClicked, setSortChangeButtonClicked] = useState(false);
  const closedSearchParams:ClosedSearchParams = useSelector((state: any) => state.closedFilterSort.filters);
  const sortParams:ClosedSortingParams = useSelector((state: any) => state.closedFilterSort.sorting);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleSortChange = () => {
    setSortChangeButtonClicked(true);
};

  
  const sendOpen = (open: any) => {
    setOpen(open);
    // if (!open) { //changing edit modal open close

    //   setEditToggle(!editToggle);
    // }
  };
  const clickEdit = (click: any) => {
    setReopenToggle(!reopenToggle);
    // setEditToggle(!editToggle); //changing edit modal open close
    history.push(rootPath + "/edit-ots");
  };

  const handleLoadedData = (data: boolean) => {
    setLoadedData(data);
  };

  function handleCardClick(otsEvent: OtsAircraft) {
    dispatch(editAircraft(otsEvent));
    history.push(rootPath + "/event-details");
  }

    const DataLevel = (data: any) => {
        setFilteredAircraft(data);
    }
//Call on page load - default closed data load
  useEffect(() => {
    async function initialSearchDataLoad() {
      //resetting to default values
      setResetPage(true);
      setFilteredCount(0);
      setIsDrawerOpen(false);
      
      setIsLoaded(false);
      try{
        const token = await getLatestAccessToken();
        userData.access_token = token;
        let updatedSearchParams = convertClosedSearchParamsForApiCall(closedSearchParams);
        const response = await getClosedEvents(userData, updatedSearchParams, sortParams);
        if(response){
          setContinousToken(response.continousToken);
          setClosedOtsDashboard(response.outOfServiceRecoveryResponse);
          setIsLoaded(true);
          try{
            if (Object.values(updatedSearchParams).some(param => Array.isArray(param) ? param.length > 0 : param)) { // Filters applied
                if (response.continousToken) { // Continuous token is truthy
                    const token = await getLatestAccessToken();
                    userData.access_token = token;
                    const countResponse = await getClosedEventsFilterCount(userData, updatedSearchParams);
                    setFilteredCount(countResponse);
                } else {
                  setFilteredCount(response.outOfServiceRecoveryResponse.length);
                }
            } else { // No filters applied
              setFilteredCount(0);
            }
          }
          catch (error) {
            setFilteredCount(0);
            console.error('Error fetching closed events count:', error);
          }
        }
        else {
          setContinousToken("");
          setClosedOtsDashboard([]);
          setIsLoaded(true);
        }
      }
      catch (error: any) {
        setContinousToken("");
        setClosedOtsDashboard([]);
        setIsLoaded(true);
        setError(error);
        console.error('Error fetching closed events:', error);
      }
    };

    if (userData.profile.company && location.pathname === rootPath) {
      initialSearchDataLoad();
    }
  }, [userData, location.pathname]);

  function removeStartingChar(item: any) {
    if (item.charAt(0) === "N") {
      item = item.substring(1);
    }
    return item;
  }

  useEffect(() => {
      setFilteredAircraft(otsClosedAircraft);
  }, [otsClosedAircraft]);

  const [filteredAircraft, setFilteredAircraft] = React.useState<OtsAircraft[]>([]);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
      return <div className="loading-container">Loading...</div>;
  } else{
    return (
      <React.Fragment>
        <Switch>
          <Route path={rootPath + "/event-details"}>
            <TitleBarClosed
              otsAircraftCount={-1}
              editClicked={clickEdit}
              contextPath={rootPath}
              isClosedEvent={false}
            ></TitleBarClosed>
            <EventDetails
              open={open}
              loadedData={handleLoadedData}
            />

            <EditModal
              contextPath={rootPath}
              sendOpen={sendOpen}
              checkOpen={open}
              loadedDataEventDetails={loadedData}
              // isEditModal={editToggle} //changing edit modal open close
              isReopenEvent={reopenToggle}
            />
          </Route>
                <Route path={rootPath + "/edit-ots"}>
                  {!closedAircraftData.IsConversationArchived &&
                    (
                    <>
                    <TitleBarClosed
                        otsAircraftCount={-1}
                        editClicked={clickEdit}
                        contextPath={rootPath}
                    ></TitleBarClosed>
                    <EventDetails
                        open={open}
                        loadedData={handleLoadedData}
                    />
                    <EditModal
                        contextPath={rootPath}
                        sendOpen={sendOpen}
                        checkOpen={open}
                        loadedDataEventDetails={loadedData}
                        // isEditModal={editToggle}  //changing edit modal open close
                        isReopenEvent={reopenToggle}
                    /></>)}
                </Route>
          <Route path={rootPath}>
                    <TitleBarClosed
                        otsAircraftCount={filteredCount}
            ></TitleBarClosed>
            <div className={`closed-dashboard-container ${isDrawerOpen  ? 'drawer-open' : ''}`}>
            <FilterNavigation
              filteredClosedData={setClosedOtsDashboard}
              continousToken={setContinousToken}
              goToFirstPage={setResetPage}
              filteredCount={setFilteredCount}
              sortButtonClicked={sortChangeButtonClicked}
              resetSortChangeButtonClicked={setSortChangeButtonClicked}
              onDrawerStateChange={(isOpen) => setIsDrawerOpen(isOpen)}
              filteredAircraftHasdata={Array.isArray(filteredAircraft) && filteredAircraft.length > 0}
          />
          <OtsCloseHeaderCard
              onSortChange={handleSortChange}
          />
                          <div className="data-container">
                          {Array.isArray(filteredAircraft) && <ShowClosedEvents aircraftdata={filteredAircraft} cardClick={handleCardClick} continousToken={continousToken} datalevel={DataLevel} resetPage={resetPage} setResetToFalse={() => setResetPage(false)}/>}
                {Array.isArray(filteredAircraft) &&  filteredAircraft.length === 0 && (
                  <div className="data-card-closed-event">
                    <div>No matching aircraft found.</div>
                  </div>
                )}
            </div>
            </div>
            <BackToTopButton />
          </Route>
        </Switch>
      </React.Fragment>
    );
  }
}